import axios from "axios";
import { apiKeyBasePath } from "../utils/apiKeys.js";

// Clinic/branch API keys (BE: clinicApiKey / branchApiKey routes). Stateless by
// design: the one-time plaintext `apiKey` returned by create/rotate is handed to
// the caller and must never be kept here.
// Errors are shown inline by components via apiKeyErrorMessage().
const QUIET = { skipGlobalErrorHandler: true };
// Best-effort side data must never bounce the user to /clinic on a 403.
const QUIET_NO_REDIRECT = { skipGlobalErrorHandler: true, skipPermissionRedirect: true };

const moduleApiKey = {
  namespaced: true,
  state: {},
  actions: {
    async fetchKeys(_ctx, { level, clinicUrl, branchUrl }) {
      const res = await axios.get(apiKeyBasePath({ level, clinicUrl, branchUrl }), QUIET);
      return res.data.data;
    },
    async createKey(_ctx, { level, clinicUrl, branchUrl, payload }) {
      const res = await axios.post(apiKeyBasePath({ level, clinicUrl, branchUrl }), payload, QUIET);
      return res.data;
    },
    async updateKey(_ctx, { level, clinicUrl, branchUrl, keyId, changes }) {
      const base = apiKeyBasePath({ level, clinicUrl, branchUrl });
      const res = await axios.put(`${base}/${encodeURIComponent(keyId)}`, changes, QUIET);
      return res.data;
    },
    async rotateKey(_ctx, { level, clinicUrl, branchUrl, keyId }) {
      const base = apiKeyBasePath({ level, clinicUrl, branchUrl });
      const res = await axios.post(`${base}/${encodeURIComponent(keyId)}/rotate`, {}, QUIET);
      return res.data;
    },
    async deleteKey(_ctx, { level, clinicUrl, branchUrl, keyId }) {
      const base = apiKeyBasePath({ level, clinicUrl, branchUrl });
      await axios.delete(`${base}/${encodeURIComponent(keyId)}`, QUIET);
    },
    async fetchUsage(_ctx, { clinicUrl }) {
      const res = await axios.get(`/api/apiKeyUsage/${encodeURIComponent(clinicUrl)}`, QUIET_NO_REDIRECT);
      return res.data;
    },
    async fetchClinicBranches(_ctx, { clinicUrl }) {
      const res = await axios.get(`/api/apiKeyBranches/${encodeURIComponent(clinicUrl)}`, QUIET_NO_REDIRECT);
      return res.data.data;
    }
  }
};

export default moduleApiKey;
